/* eslint-disable no-mixed-spaces-and-tabs,no-tabs,@typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerExecuteSqlComponent', [
    '$rootScope',
    'DesignerBaseSourceAndDestinationComponent',
    'DesignerConnection',

    function ($rootScope, DesignerBaseSourceAndDestinationComponent, DesignerConnection) {
      const OPERATOR = {
        AND: 'and',
        OR: 'or',
      };

      function DesignerExecuteSqlComponent() {
        DesignerBaseSourceAndDestinationComponent.apply(this);

        this.connection = new DesignerConnection();
        this.query = null;
        this.result_type = null;
        this.result_variable = null;
        this.operator = null;
      }

      DesignerExecuteSqlComponent.prototype = new DesignerBaseSourceAndDestinationComponent();

      DesignerExecuteSqlComponent.prototype.getData = function () {
        const data = DesignerBaseSourceAndDestinationComponent.prototype.getData.call(this);

        _.extend(data, {
          connection: this.connection.getData(),
          query: this.query,
          result_type: this.result_type || 'none',
          result_variable: this.result_variable || '',
          operator: this.operator || OPERATOR.AND,
        });

        return data;
      };

      DesignerExecuteSqlComponent.prototype.getFormData = function () {
        const data = DesignerBaseSourceAndDestinationComponent.prototype.getFormData.call(this);

        return data;
      };

      DesignerExecuteSqlComponent.prototype.setFormData = function (data) {
        this.setData(data);

        DesignerBaseSourceAndDestinationComponent.prototype.setFormData.call(this, data);
      };

      DesignerExecuteSqlComponent.prototype.setData = function (data) {
        this.connection.setData(data.connection);
        this.query = data.query;
        this.result_type = data.result_type;
        this.result_variable = data.result_variable;
        this.operator = data.operator;

        DesignerBaseSourceAndDestinationComponent.prototype.setData.call(this, data);
      };

      DesignerExecuteSqlComponent.prototype.getSchema = function () {
        const schema = DesignerBaseSourceAndDestinationComponent.prototype.getSchema.call(this);

        return schema;
      };

      DesignerExecuteSqlComponent.prototype.valid = function (data) {
        let isValid = true;
        let queryValid;
        let isVariableValid;
        const currentPackage = $rootScope.getPackage();

        if (currentPackage) {
          const packageVariables = angular.copy(currentPackage.variables);
          if (data) {
            queryValid = data.query && data.query.length > 0;
            isVariableValid = angular.isDefined(packageVariables[data.result_variable]);
            isValid = queryValid;
            if (data.result_type !== 'none') isValid = isValid && isVariableValid;
          } else {
            queryValid = this.query && this.query.length > 0;
            isVariableValid = angular.isDefined(packageVariables[this.result_variable]);
            isValid = queryValid;
            if (this.result_type !== 'none') isValid = isValid && isVariableValid;
          }
        }

        return isValid;
      };

      return DesignerExecuteSqlComponent;
    },
  ]);
})(window.angular);
